import { AppBarProps } from "../types";
import personIcon from "../assests/personIcon.svg";
import GetUser from "../utils/getUser";
import BrandMark from "./brand-mark";

export default function AppBar({ profileInfo }: AppBarProps) {
  const currentUser = GetUser();

  return (
    <div className="h-auto min-h-[80px] sm:min-h-[100px] bg-surface border-b border-edge w-full px-4 sm:px-6 lg:px-10 flex flex-col justify-center shadow-card animate-fade-in relative">
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/30 to-transparent pointer-events-none" />
      <div className="flex justify-between w-full items-center gap-3 py-3">
        <h1 className="flex items-center justify-start">
          <BrandMark size="sm" />
        </h1>
        {profileInfo ? (
          <div className="flex items-center gap-2 sm:gap-3 rounded-full border border-edge bg-surface-elevated py-2 pl-2 pr-3 sm:pr-5 transition-shadow duration-300 hover:shadow-glow-sm">
            <img
              src={personIcon}
              alt=""
              className="h-9 w-9 sm:h-12 sm:w-12 rounded-full ring-2 ring-indigo-500/30"
            />
            <span className="hidden sm:block">
              <p className="font-[390] text-[16px] sm:text-[18px] text-text-primary tracking-[0.529px] font-heading-font">
                {currentUser?.name}
              </p>
              <p className="text-xs sm:text-sm font-[700] text-light-gray capitalize font-heading-font">
                {currentUser?.type?.replace("-", " ")}
              </p>
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
}
